import Table, { ColumnsType } from "antd/es/table";
import { localizeDate, isUserHasRoleTypes } from "../../../utils";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Button, Popconfirm } from "antd";
import { useAppSelector } from "../../../redux/hooks";

const PaymentTable = (props: any) => {
  const { data, title, onUpdatePaymentModal, onDeletePayment, assignmentId } = props;
  const auth = useAppSelector<any>((store) => store.auth);
  const user = auth.user;

  const isSuperUser = (user: any) => {
    return isUserHasRoleTypes(user, ["super_user"]);
  };

  const isFinanceController = (user: any) => {
    return isUserHasRoleTypes(user, ["finance_controller"]);
  };

  const columns: ColumnsType<any> = [
    {
      title: "Payment Ref Number",
      dataIndex: "payment_ref_number",
      key: "payment_ref_numbe"
    },
    {
      title: "Payment Date",
      dataIndex: "payment_date",
      key: "payment_date",
      render: (payment_date) => <>{payment_date ? localizeDate(payment_date) : "-"}</>
    },
    {
      title: "Payment Amount",
      dataIndex: "payment_amount",
      key: "payment_amount"
    },
    {
      title: "Payment Party Code",
      dataIndex: "payment_party_code",
      key: "payment_party_code"
    },
    {
      title: "Bank Name",
      dataIndex: "bank_name",
      key: "bank_name"
    }
    ,
    {
      title: "Payment Gateway ID",
      dataIndex: "payment_gateway_id",
      key: "payment_gateway_id"
    },
    {
      title: "Customer Bank",
      dataIndex: "customer_bank",
      key: "customer_bank"
    },
    {
      title: "Customer VPA",
      dataIndex: "customer_vpa",
      key: "customer_vpa"
    },
    {
      title: "Payment Description",
      dataIndex: "payment_description",
      key: "payment_description"
    },
    {
      title: "Payment RRN",
      dataIndex: "payment_rrn",
      key: "payment_rrn"
    }
  ];

  const actionColumn = {
    title: "Action",
    key: "action",
    render: (_: any, paymentdata: any) => (
      <>
        <Button
          icon={<EditOutlined />}
          onClick={() => onUpdatePaymentModal(paymentdata, "payment")}
          title="Update"
        ></Button>
        <Popconfirm
          title="Are you sure you want to delete payment details"
          okText="Delete"
          placement="bottom"
          cancelText="Cancel"
          onConfirm={(event) => {
            onDeletePayment(assignmentId, paymentdata.id);
          }}
          onCancel={(event: any) => event.stopPropagation()}
        >
          <Button icon={<DeleteOutlined />} title="Delete"></Button>
        </Popconfirm>
      </>
    )
  };

  if (isSuperUser(user) || isFinanceController(user)) {
    columns.push(actionColumn);
  }

  return (
    <div style={{ marginTop: 50 }}>
      <h2>{title}</h2>
      <Table
        rowKey="id"
        bordered
        columns={columns}
        pagination={false}
        dataSource={data}
        scroll={{ x: 400 }}
      />
    </div>
  );
};

export default PaymentTable;
